import React from 'react';
import { Link } from 'react-router';

const Breadcrumbs = ({ items }) => {
  return (
    <ul className="breadcrumbs">
      { items.map((item, i) => {
        const isLast = i === items.length - 1;

        return (
          <li key={i}>
            <Link to={item.url}>{ item.title }</Link>
            { !isLast && <span className="separator">></span> }
          </li>
        );
      }) }
    </ul>
  );
}

export default Breadcrumbs;



// WEBPACK FOOTER //
// ./common/components/breadcrumbs.jsx